import { Bot, UtensilsCrossed, CalendarCheck, LayoutDashboard, Inbox, Receipt, Wrench } from "lucide-react";
import { useLanguage } from "@/lib/LanguageContext";

// El asistente va en una tarjeta grande aparte y el resto en la grilla: es lo
// unico que ningun competidor a este precio ofrece, y ademas esta funcionando
// en esta misma pagina, asi que el visitante puede probarlo sin irse.
const ICONS = [UtensilsCrossed, CalendarCheck, LayoutDashboard, Inbox, Receipt, Wrench];

export default function Tools() {
    const { t } = useLanguage();
    const f = t.tools.featured;

    return (
        <section id="tools" className="ps-section ps-relative-z" data-testid="tools-section">
            <div className="ps-container">
                <div className="ps-section-head">
                    <h2 className="ps-display ps-section-title" data-split data-split-scroll data-testid="tools-title"
                        dangerouslySetInnerHTML={{ __html: t.tools.title }} />
                    <p className="ps-services-subtitle ps-fade" data-testid="tools-subtitle">
                        {t.tools.subtitle}
                    </p>
                </div>

                <div className="ps-tool-hero ps-fade" data-testid="tools-featured">
                    <div className="ps-tool-hero-main">
                        <span className="ps-tool-badge ps-mono">{f.badge}</span>
                        <h3 className="ps-tool-hero-title">{f.title}</h3>
                        <p className="ps-tool-hero-desc">{f.desc}</p>
                        <p className="ps-tool-hero-note">{f.note}</p>
                    </div>
                    <div className="ps-tool-hero-side">
                        <div className="ps-tool-hero-icon" aria-hidden="true">
                            <Bot size={22} strokeWidth={1.6} />
                        </div>
                        <ul className="ps-tool-points">
                            {f.points.map((p) => (
                                <li key={p}>
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="15" height="15" aria-hidden="true">
                                        <path d="M20 6 9 17l-5-5" />
                                    </svg>
                                    <span>{p}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className="ps-tools-grid" data-testid="tools-list">
                    {t.tools.items.map((item, i) => {
                        const Icon = ICONS[i] ?? Wrench;
                        return (
                            <div key={item.title} className="ps-tool ps-fade" data-testid={`tool-${i + 1}`}>
                                <div className="ps-service-icon" aria-hidden="true">
                                    <Icon size={18} strokeWidth={1.75} />
                                </div>
                                <h3 className="ps-tool-title">{item.title}</h3>
                                <p className="ps-tool-desc">{item.desc}</p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
